import { lazy } from "react";
import { route, routes } from "~/helpers/routeHelper";
import { TRoute } from "~/types/global";

const Dashboard = lazy(() => import("~/pages/Dashboard/index"));
const Login = lazy(() => import("~/pages/Authentication/Login"));
const UserProfile = lazy(() => import("~/pages/User/Profile"));
const Logout = lazy(() => import("~/pages/Authentication/Logout"));
const UserPassword = lazy(() => import("~/pages/User/Password"));
const LostPassword = lazy(() => import("~/pages/User/LostPassword"));
const ResetPassword = lazy(() => import("~/pages/User/ResetPassword"));
const ActivateAccount = lazy(() => import("~/pages/User/ActivateAccount"));
const VerifyEmail = lazy(() => import("~/pages/User/VerifyEmail"));
const TwoFactorAuth = lazy(() => import("~/pages/Authentication/TwoFactorAuth"));
const Auth0Callback = lazy(() => import("~/pages/Authentication/Auth0Callback"));
const OAuthAuthorize = lazy(() => import("~/pages/Authentication/OAuthAuthorize"));

const publicRoutes: TRoute[] = [
  { path: route(routes.login), component: Login, isStrict: true },
  { path: route(routes.lost_password), component: LostPassword, isStrict: true },
  { path: route(routes.reset_password), component: ResetPassword, isStrict: true },
  { path: route(routes.activate_account), component: ActivateAccount },
  { path: route(routes.verify_email), component: VerifyEmail },
  { path: route(routes.two_factor_auth), component: TwoFactorAuth },
  { path: route(routes.auth0_callback), component: Auth0Callback },
  { path: route(routes.oauth_authorize), component: OAuthAuthorize },
];

const protectedRoutes: TRoute[] = [
  { path: route(routes.home), component: Dashboard },
  { path: route(routes.view_me), component: UserProfile },
  { path: route(routes.change_my_password), component: UserPassword },
  { path: route(routes.logout), component: Logout },
];

export { publicRoutes, protectedRoutes }
